




























































































import { Component, Emit, Prop, Vue, Watch } from 'vue-property-decorator';
import { HolidayExecutionType } from '@/API';
import LabelInput from '@/components/molecules/LabelInput.vue';
import { i18n } from '@/plugins/i18n/i18n';
import { isEmptyArray } from '@/utils/CommonUtils';
import { TriggerOnHolidays, PUBLIC_HOLIDAY } from '@/utils/consts';

@Component({ components: { LabelInput } })
export default class HolidaySettingCard extends Vue {
  @Prop()
  private loading!: string;

  @Prop()
  private triggerType!: HolidayExecutionType;

  @Prop()
  private triggerOnHolidays!: TriggerOnHolidays;

  @Prop()
  private allLabels!: string[];

  @Prop()
  private inputtedLabels!: string[];

  @Prop()
  private existingLabels!: string[];

  @Prop({ required: false, default: false })
  private isReadOnly!: boolean;

  private isTriggerTypeNoChange: boolean = true;
  private showLabelInput: boolean = false;

  private triggerTypeValue!: HolidayExecutionType;

  private triggerOnHolidaysValue!: TriggerOnHolidays;

  private TriggerType = HolidayExecutionType;
  private TriggerOnHolidays = TriggerOnHolidays;

  public async created(): Promise<void> {
    this.showLabelInput =
      this.triggerOnHolidays === TriggerOnHolidays.customHolidays;
    this.isTriggerTypeNoChange = this.triggerType === this.TriggerType.NoChange;
    this.triggerTypeValue = this.triggerType;
    this.triggerOnHolidaysValue = this.triggerOnHolidays;
  }

  private setPublicHoliday() {
    if (isEmptyArray(this.inputtedLabels)) {
      this.inputtedLabels.unshift(PUBLIC_HOLIDAY);
    }
  }

  @Emit('changedTriggerType')
  private onTriggerTypeChange(triggerType: HolidayExecutionType) {
    if (this.triggerTypeValue === HolidayExecutionType.NoChange) {
      this.triggerOnHolidaysValue = TriggerOnHolidays.allHolidays;
      this.showLabelInput = false;
      this.isTriggerTypeNoChange = true;
    } else {
      this.isTriggerTypeNoChange = false;
    }
    return this.triggerTypeValue;
  }

  @Emit('changedHolidayLabels')
  private changeHolidayLabels(holidayLabels: string[]) {}

  @Emit('changedTriggerOnHolidays')
  private onTriggerOnHolidaysChange(triggerOnHolidays: TriggerOnHolidays) {}

  @Emit('validationErrorInHolidaySettingCard')
  @Watch('triggerTypeValue')
  @Watch('triggerOnHolidaysValue')
  @Watch('inputtedLabels')
  private doesAnyErrorExists(): boolean {
    const isInvalid =
      this.triggerTypeValue !== HolidayExecutionType.NoChange &&
      this.triggerOnHolidaysValue === TriggerOnHolidays.customHolidays &&
      isEmptyArray(this.inputtedLabels);
    return isInvalid;
  }
}
